export const SCROLL_TO = {
  INSTITUTION: 'Institutions',
  BUILD_YOUR_TARGET: 'Build Your Target',
  CAREER_SCROLLERS: 'Career Scrollers',
  /* Where finishing the skills survey lands: the button says "See my
     matches", and the matches are partway down Build Your Target. */
  OCCUPATION_MATCHES: 'Occupation Matches',
};
